import React from 'react';
import { Card } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { IntegrationBrand } from './IntegrationBrand';

export const IntegrationsBrandStatus = () => {
  return (
    <Card className="overflow-hidden mt-3">
      <Card.Body className="p-0" style={{ overflowX: 'scroll' }}>
        <Table borderless responsive className="mb-0 fs--1">
          <thead className="bg-light">
            <tr>
              <th colSpan={3}>
                <small>
                  Actualmente las siguientes aplicaciones se encuentran
                  integradas o realizando integraciones con CABAPROP, para que
                  puedas utilizarlas en tu inmobiliaria. Aquí puede ver el
                  estado de cada una de ellas.
                </small>
              </th>
            </tr>

            <tr className="text-900">
              <th>Integraciones de Aplicación</th>
              <th className="pe-x1 text-end" style={{ width: '8rem' }}>
                Progreso
              </th>
            </tr>
          </thead>
          <tbody>
            <IntegrationBrand />
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};
